import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { nanoid } from 'nanoid';
export const useDropMultiFileStatus = (value, onChange) => {
  const addFile = React.useCallback(file => {
    var _value$accepted, _value$rejected;
    onChange && onChange({
      accepted: [...((_value$accepted = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted !== void 0 ? _value$accepted : []), {
        file,
        id: nanoid()
      }],
      rejected: (_value$rejected = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected !== void 0 ? _value$rejected : []
    });
  }, [value, onChange]);
  const addFiles = React.useCallback(files => {
    var _value$accepted2, _value$rejected2;
    onChange && onChange({
      accepted: [...((_value$accepted2 = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted2 !== void 0 ? _value$accepted2 : []), ...files.map(file => ({
        file,
        id: nanoid()
      }))],
      rejected: (_value$rejected2 = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected2 !== void 0 ? _value$rejected2 : []
    });
  }, [value, onChange]);
  const addFileRejected = React.useCallback(file => {
    var _value$rejected3, _value$accepted3;
    onChange && onChange({
      rejected: [...((_value$rejected3 = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected3 !== void 0 ? _value$rejected3 : []), file],
      accepted: (_value$accepted3 = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted3 !== void 0 ? _value$accepted3 : []
    });
  }, [value, onChange]);
  const addFilesRejected = React.useCallback(files => {
    var _value$rejected4, _value$accepted4;
    onChange && onChange({
      rejected: [...((_value$rejected4 = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected4 !== void 0 ? _value$rejected4 : []), ...files],
      accepted: (_value$accepted4 = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted4 !== void 0 ? _value$accepted4 : []
    });
  }, [value, onChange]);
  const remove = React.useCallback(id => {
    if (onChange) {
      var _value$accepted5;
      const newAccepted = [...((_value$accepted5 = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted5 !== void 0 ? _value$accepted5 : [])];
      const index = newAccepted.findIndex(item => item.id === id);
      if (index !== -1) {
        var _value$rejected5;
        newAccepted.splice(index, 1);
        onChange({
          accepted: newAccepted,
          rejected: (_value$rejected5 = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected5 !== void 0 ? _value$rejected5 : []
        });
      }
    }
  }, [value, onChange]);
  const removeRejected = React.useCallback(file => {
    if (onChange) {
      var _value$rejected6;
      const newRejected = [...((_value$rejected6 = value === null || value === void 0 ? void 0 : value.rejected) !== null && _value$rejected6 !== void 0 ? _value$rejected6 : [])];
      const index = newRejected.findIndex(item => item.file === file);
      if (index !== -1) {
        var _value$accepted6;
        newRejected.splice(index, 1);
        onChange({
          rejected: newRejected,
          accepted: (_value$accepted6 = value === null || value === void 0 ? void 0 : value.accepted) !== null && _value$accepted6 !== void 0 ? _value$accepted6 : []
        });
      }
    }
  }, [value, onChange]);
  const removeAll = React.useCallback(() => {
    onChange && onChange({
      accepted: [],
      rejected: []
    });
  }, [onChange]);
  return {
    addFile,
    addFiles,
    addFileRejected,
    addFilesRejected,
    remove,
    removeRejected,
    removeAll
  };
};